import { render } from "./reviews-list.html?vue&type=template&id=1ac81859"
import script from "./ReviewsList.vue?vue&type=script&lang=ts"
export * from "./ReviewsList.vue?vue&type=script&lang=ts"

import "./reviews-list.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script